import { FORGOT_PASSWORD } from "../configs/routes";
import api from "./api";

export const forgotPassword = async (body) => {
  const response = await api.post(FORGOT_PASSWORD, body);
  return response.data;
};
